import { render, staticRenderFns } from "./AuthSideKey.vue?vue&type=template&id=398188fd&scoped=true&"
import script from "./AuthSideKey.vue?vue&type=script&lang=js&"
export * from "./AuthSideKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398188fd",
  null
  
)

export default component.exports